<template>
  <div class="page-job">
    <banner :img="bannerImg" title="人才招聘" titleEng="Job"></banner>
    <div class="section" >
      <div class="section-content" :style="{backgroundImage: `url(${bgContent})`}">
        <p class="c-title animate__animated animate__fadeInLeft">人才招聘</p>
        <p class="e-Title animate__animated animate__fadeInLeft">Job</p>
        <el-collapse>
          <el-collapse-item v-for="item in jobList" :key="item.id">
            <template slot="title">
              <div class="header">
                <div>{{ item.title }}</div>
                <div>{{ item.descContent }}</div>
              </div>
            </template>
            <div>
              <div v-html="item.htmlContent" style="padding: 16px;"></div>
              <el-button @click="handleApplicate(item)" style="margin: 30px 16px;">在线应聘</el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <el-dialog :visible.sync="showDialog" title="在线应聘" :close-on-click-modal="false">
      <el-form :model="info" :rules="rules" label-position="left" label-width="90px" ref="form">
        <el-form-item label="应聘职位" prop="post">
          <el-input v-model="info.post"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="info.name"></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input v-model="info.age"></el-input>
        </el-form-item>
        <el-form-item label="教育经历" prop="educationUndergo">
          <el-input v-model="info.educationUndergo" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="工作经历" prop="workUndergo">
          <el-input v-model="info.workUndergo" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="自我介绍" prop="selfIntroduction">
          <el-input v-model="info.selfIntroduction" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="求职意向" prop="jobIntention">
          <el-input v-model="info.jobIntention" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="info.phone"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="info.email"></el-input>
        </el-form-item>
        <el-form-item label="目前年薪" prop="salaryCurrent">
          <el-input v-model="info.salaryCurrent"></el-input>
        </el-form-item>
        <el-form-item label="期望年薪" prop="salaryDesire">
          <el-input v-model="info.salaryDesire"></el-input>
        </el-form-item>
        <el-form-item label="上传简历">
          <el-upload accept=".docx, .doc, .pdf" ref="upload" action="#" :auto-upload="false" :show-file-list="false" :on-change="beforeUpload">
            <div class="upload" @click="openFile">
              <div v-if="file" style="text-align: center;margin-right: 20px;">
                <img src="../assets/img/file.png" alt="" style="width: 24px;">
                <div class="file-name">{{ file.name }}</div>
              </div>
              <el-button>{{ file ? '修改' : '上传' }}</el-button>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import { getArticleByCateId,upload,saveJob,getWebsiteConfigList } from '../api';
import { checkMobile,checkEmail } from '../utils/check'
export default {
  components: { Banner },
  data() {
    return {
      jobList: [],
      showDialog: false,
      info: {
        post: '',
        name: '',
        age: '',
        educationUndergo: '',
        workUndergo: '',
        selfIntroduction: '',
        jobIntention: '',
        phone: '',
        email: '',
        salaryCurrent: '',
        salaryDesire: ''
      },
      rules: {
        post: [
          {required: true, message: '请输入应聘职位'}
        ],
        name: [
          {required: true, message: '请输入姓名'}
        ],
        age: [
          {required: true, message: '请输入年龄'},
          { pattern: /^(?:[1-9]\d*)$/ , message: '请输入正确的年龄', trigger: "blur"}
        ],
        educationUndergo: [
          {required: true, message: '请输入教育经历'}
        ],
        workUndergo: [
          {required: true, message: '请输入工作经历'}
        ],
        selfIntroduction: [
          {required: true, message: '请输入自我介绍'}
        ],
        jobIntention: [
          {required: true, message: '请输入求职意向'}
        ],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (!checkMobile(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
            required: true
          },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              if (!checkEmail(value)) {
                callback(new Error("请输入正确的邮箱"));
              } else {
                callback();
              }
            },
            trigger: "blur",
            required: true
          },
        ],
        salaryCurrent: [
          {required: true, message: '请输入目前年薪'}
        ],
        salaryDesire: [
          {required: true, message: '请输入期望年薪'}
        ]
      },
      file: null,
      bgContent: '',
      bannerImg: ''
    }
  },
  created() {
    getArticleByCateId({cateId: '10'}).then(res => {
      this.jobList = res.data.filter(item => item.title !== '招贤纳士')
    })
    getWebsiteConfigList().then(res => {
      this.bgContent = res.data.some(item => item.code === 'bg_recruit') ? res.data.find(item => item.code === 'bg_recruit').title : ''
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_recruit') ? res.data.find(item => item.code === 'bg_banner_recruit').title : ''
    })
  },
  methods: {
    handleApplicate(item) {
      this.info.post = item.title
      this.file = null
      this.showDialog = true
    },
    beforeUpload(file) {
      if (file.size > 1024*1024*10) {
        this.$message.warning('上传文件不能大于10M')
        return false
      }
      let formdata = new FormData()
      formdata.append('file', file.raw)
      upload(formdata).then((res) => {
        this.file = res.data
      })
    },
    openFile() {
      this.$refs.upload.clearFiles()
    },
    handleSubmit() {
      if (!checkEmail(this.info.email)) {
        this.$message.warning('请输入正确的邮箱')
        return
      }
      if (!checkMobile(this.info.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          saveJob({...this.info, resumeFileId: this.file ? this.file.id : ''}).then(() => {
            this.$message.success('提交成功')
            this.showDialog = false
            this.info = {
              post: '',
              name: '',
              age: '',
              educationUndergo: '',
              workUndergo: '',
              selfIntroduction: '',
              jobIntention: '',
              phone: '',
              email: '',
              salaryCurrent: '',
              salaryDesire: ''
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-job {
  background-color: #14679f;
  .section {
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      padding: 40px;
      min-height: 250px;
      .c-title {
        font-size: 25px;
        color: #3e466b;
        font-weight: 500;
        // margin: 0 150px;
      }
      .e-Title {
        font-size: 16px;
        color: #3e466b;
        padding: 8px 0;
        font-weight: 400;
        width: 100px;
        // text-align: center;
        margin-bottom: 30px;
      }
    }
    .header {
      line-height: 24px;
      padding: 10px 8px 8px 16px;
      font-size: 17px;
    }
  }
  ::v-deep {
    .el-collapse-item {
      box-shadow: 0 0 2px #eee;
    }
    .el-collapse-item__header {
      height: auto;
    }
  }
  .upload {
    display: flex;
    align-items: center;
  }
  .file-name {
    font-size: 13px;
    line-height: 18px;
  }
}

@media screen and (max-width: 997px) {
  .page-job {
    .section {
      &-content {
        width: calc(100% - 20px);
      }
    }
  }
  ::v-deep {
    .el-dialog {
      width: calc(100% - 10px);
    }
  }
}
</style>